//--- NPM packages style ---
import './public_path';

// bootstrap
require('bootstrap/dist/css/bootstrap.min.css');

// bootstrap-colorpicker
require('bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css');

// bootstrap-select
require('bootstrap-select/dist/css/bootstrap-select.min.css');

// select2
require('select2/dist/css/select2.min.css');

//select2-bootstrap-theme
require('select2-bootstrap-theme/dist/select2-bootstrap.min.css');

// jquery-ui
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/menu.css');
require('jquery-ui/themes/base/autocomplete.css');
require('jquery-ui/themes/base/theme.css');

// toastr
require('toastr/build/toastr.min.css');

// bootstrap-switch
require('bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css');

// bootstrap-slider
require('bootstrap-slider/dist/css/bootstrap-slider.min.css');

// bootstrap-tagsinput
require('bootstrap-tagsinput/dist/bootstrap-tagsinput.css');

// font-awesome
require('font-awesome/css/font-awesome.min.css');

// datatables.net-dt
require('datatables.net-bs/css/dataTables.bootstrap.css');
require('datatables.net-buttons-dt/css/buttons.dataTables.min.css');

// timepicker
require('timepicker/jquery.timepicker.min.css');

// bootstrap-tour
require('bootstrap-tour/build/css/bootstrap-tour.min.css');

require('./src/vendor/calendar/css/calendar.css');
require('./src/vendor/jquery-file-upload/css/jquery.fileupload.css');
require('./src/vendor/jquery-file-upload/css/jquery.fileupload-ui.css');
require('./src/vendor/bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css');
require('./src/vendor/jquery-ui/css/ui-lightness/jquery-ui-1.10.2.custom.min.css');




// WEBPACK FOOTER //
// ./ui/bundle_style.js